/*
 *
 * Invoice constants
 *
 */

export const DEFAULT_ACTION = 'app/Invoices/DEFAULT_ACTION';
